import { makeSecuredMediaURLRelative } from '@lumapps/medias/utils';
import { useTranslate } from '@lumapps/translations';
import { getCurrentTimezoneFormated } from '@lumapps/utils/timezones/getCurrentTimezone';
import { getFormatedDate } from '@lumapps/widget-event-metadata/components/BlockEventMetadata/getFormatedDate';
import { DITA } from '@lumapps/wrex-core/serialization/dita/types';
import { featuredImageFromDita } from '@lumapps/wrex-core/serialization/dita/utils/featuredImageFromDita';

import { Event } from '../types';

export const useEventBlock = (event: Event) => {
    const { translateObject } = useTranslate();

    const imageInfos = () => {
        const featuredImage = featuredImageFromDita(
            translateObject((event as Event).structuredContent.dita?.translations) as DITA,
        );

        return featuredImage
            ? {
                  alt: featuredImage && featuredImage.alt,
                  url: featuredImage && (makeSecuredMediaURLRelative(featuredImage.url) as string),
                  focusPoint: featuredImage && featuredImage.focalPoint,
              }
            : undefined;
    };

    const title = translateObject((event as Event).structuredContent.title?.translations);

    const intro = translateObject((event as Event).structuredContent.intro?.translations);

    const formatedTimezone = getCurrentTimezoneFormated();

    const { formatedStartDate, formatedEndDate } = getFormatedDate(event.startsAt, event.endsAt);

    return {
        id: event.id,
        image: imageInfos(),
        author: event.author,
        title,
        formatedStartDate,
        formatedEndDate,
        formatedTimezone,
        createdAt: event.createdAt,
        intro,
    };
};
